<template>
  <header class="rd-header">
    <div class="rd-shell rd-header-inner">
      <router-link to="/" class="rd-brand" aria-label="Waajo">
        <img
          v-if="!logoError"
          :src="logoText"
          :alt="appTitle"
          @error="logoError = true"
        />
        <span v-else class="rd-brand-fallback">waajo</span>
      </router-link>

      <nav v-if="!minimal" class="rd-nav" aria-label="Navigasi utama">
        <router-link v-if="isLoggedIn" to="/index" class="rd-nav-link">
          <i class="fa fa-th-large" aria-hidden="true"></i>
          Dashboard
        </router-link>
        <router-link
          :to="{ name: 'subscriptions' }"
          class="rd-nav-link"
        >
          <i class="fa fa-th" aria-hidden="true"></i>
          Paket
        </router-link>
        <router-link
          v-if="isLoggedIn"
          to="/order/list"
          class="rd-nav-link"
        >
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          Pesanan
        </router-link>
        <span v-if="isLoggedIn" class="rd-nav-user">
          <i class="fa fa-user-circle-o" aria-hidden="true"></i>
          {{ sessionName }}
        </span>
        <router-link
          v-if="!isLoggedIn"
          :to="loginTarget"
          class="rd-nav-link"
        >
          <i class="fa fa-sign-in" aria-hidden="true"></i>
          Masuk
        </router-link>
        <router-link v-if="!isLoggedIn" to="/subscriptions" class="rd-nav-link">
          <i class="fa fa-user-plus" aria-hidden="true"></i>
          Daftar
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
import { getMemberSession } from "@/utils/auth";

export default {
  name: "redesign-header",
  props: {
    minimal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE || "WAAJO.ID",
      logoText: process.env.VUE_APP_LOGO_TEXT || "static/assetswaajo/logo-text.png",
      logoError: false
    };
  },
  computed: {
    memberSession() {
      try {
        const raw = getMemberSession();
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    },
    isLoggedIn() {
      return !!this.memberSession;
    },
    sessionName() {
      if (!this.memberSession) {
        return "Akun";
      }
      return (
        this.memberSession.name ||
        this.memberSession.email ||
        this.memberSession.phone ||
        "Akun"
      );
    },
    loginTarget() {
      const currentPath =
        this.$route && this.$route.fullPath ? this.$route.fullPath : "";
      const isLoginPath =
        currentPath.indexOf("/login") === 0 ||
        currentPath.indexOf("/redesign/login") === 0;
      if (currentPath && !isLoginPath) {
        return {
          name: "login",
          query: { redirect: currentPath }
        };
      }
      return { name: "login" };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/redesign/components/RedesignHeader.vue